import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import People from "@/pages/People";
import AttorneyBio from "@/pages/AttorneyBio";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import PracticeArea from "@/pages/PracticeArea";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import News from "@/pages/News";
import NewsPost from "@/pages/NewsPost";
import Resources from "@/pages/Resources";
import Join from "@/pages/Join";
import Legal from "@/pages/Legal";
import LegalLinks from "@/pages/LegalLinks";
import CCL from "@/pages/CCL";
import CCLCategory from "@/pages/CCLCategory";
import CCLEntry from "@/pages/CCLEntry";
import USML from "@/pages/USML";
import USMLCategory from "@/pages/USMLCategory";
import USMLParagraph from "@/pages/USMLParagraph";
import LicenseCheck from "@/pages/LicenseCheck";
import EARExceptions from "@/pages/EARExceptions";
import EARExceptionDetail from "@/pages/EARExceptionDetail";
import ITARExemptions from "@/pages/ITARExemptions";
import ITARExemptionDetail from "@/pages/ITARExemptionDetail";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPostEditor from "@/pages/admin/AdminPostEditor";
import AdminResources from "@/pages/admin/AdminResources";
import AdminResourceEditor from "@/pages/admin/AdminResourceEditor";
import AdminCCLChanges from "@/pages/admin/AdminCCLChanges";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/people" element={<People />} />
            <Route path="/people/:slug" element={<AttorneyBio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<PracticeArea />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsPost />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/join" element={<Join />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/legal-links" element={<LegalLinks />} />
            <Route path="/ccl" element={<CCL />} />
            <Route path="/ccl/e/:eccn" element={<CCLEntry />} />
            <Route path="/ccl/:number" element={<CCLCategory />} />
            <Route path="/usml" element={<USML />} />
            <Route path="/usml/e/:roman/:letter" element={<USMLParagraph />} />
            <Route path="/usml/:roman" element={<USMLCategory />} />
            <Route path="/tools/license-check" element={<LicenseCheck />} />
            <Route path="/tools/ear-license-exceptions" element={<EARExceptions />} />
            <Route path="/tools/ear-license-exceptions/:slug" element={<EARExceptionDetail />} />
            <Route path="/tools/itar-license-exemptions" element={<ITARExemptions />} />
            <Route path="/tools/itar-license-exemptions/:slug" element={<ITARExemptionDetail />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/posts/new" element={<ProtectedRoute><AdminPostEditor /></ProtectedRoute>} />
            <Route path="/admin/posts/:id/edit" element={<ProtectedRoute><AdminPostEditor /></ProtectedRoute>} />
            <Route path="/admin/resources" element={<ProtectedRoute><AdminResources /></ProtectedRoute>} />
            <Route path="/admin/resources/new" element={<ProtectedRoute><AdminResourceEditor /></ProtectedRoute>} />
            <Route path="/admin/resources/:id/edit" element={<ProtectedRoute><AdminResourceEditor /></ProtectedRoute>} />
            <Route path="/admin/ccl/changes" element={<ProtectedRoute><AdminCCLChanges /></ProtectedRoute>} />

            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
